"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _CollapsibleTrigger = _interopRequireDefault(require("./CollapsibleTrigger.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CollapsibleTrigger = function CollapsibleTrigger(_ref) {
  var actions = _ref.actions,
    titleText = _ref.titleText,
    titleValue = _ref.titleValue,
    disabledCollapse = _ref.disabledCollapse,
    onDelete = _ref.onDelete,
    noCollapse = _ref.noCollapse;
  return /*#__PURE__*/_react["default"].createElement(_CollapsibleTrigger["default"], {
    className: "CollapsibleHeader",
    disabledCollapse: disabledCollapse
  }, titleText, titleValue ? ': ' : '', " ", /*#__PURE__*/_react["default"].createElement("b", null, titleValue), !disabledCollapse && !noCollapse && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-arrow-dropdown",
    size: 24,
    className: "toggle-icon"
  }), actions && R.map(function (action) {
    return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      key: "".concat(action.icon, "action"),
      icon: action.icon,
      size: 24,
      onClick: action.clickHandler
    });
  }, actions), onDelete && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "collapsible-trigger-delete",
    icon: "ion-android-delete",
    onClick: function onClick(e) {
      e.stopPropagation();
      onDelete();
    },
    size: 16
  }));
};
CollapsibleTrigger.defaultProps = {
  actions: [],
  titleValue: undefined,
  disabledCollapse: false,
  onDelete: null,
  noCollapse: false
};
CollapsibleTrigger.propTypes = {
  /** Elements to be displayed at the right side of the collapsible toggle (eg. Delete button) */
  actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    clickHandler: _propTypes["default"].func,
    icon: _propTypes["default"].string
  })),
  /** A title to be rendered in left side of the collapsible title bar (eg. `Eligibility rule` ) */
  titleText: _propTypes["default"].string.isRequired,
  /** A title to be rendered in left side of the collapsible title bar;
   * will be highlithed (eg. Car allowance)
   * */
  titleValue: _propTypes["default"].string,
  /** Flag to indicate if the trigger should be disabled; Will not have a toggle icon. */
  disabledCollapse: _propTypes["default"].bool,
  /** Callback to handle deletion of the Collapsible Block */
  onDelete: _propTypes["default"].func,
  /** Flag to hide the collapse button */
  noCollapse: _propTypes["default"].bool
};
CollapsibleTrigger.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CollapsibleTrigger",
  "props": {
    "actions": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "Elements to be displayed at the right side of the collapsible toggle (eg. Delete button)",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "clickHandler": {
              "name": "func",
              "required": false
            },
            "icon": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false
    },
    "titleValue": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "A title to be rendered in left side of the collapsible title bar;\r\nwill be highlithed (eg. Car allowance)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabledCollapse": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to indicate if the trigger should be disabled; Will not have a toggle icon.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onDelete": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Callback to handle deletion of the Collapsible Block",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "noCollapse": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to hide the collapse button",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "titleText": {
      "description": "A title to be rendered in left side of the collapsible title bar (eg. `Eligibility rule` )",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(CollapsibleTrigger);
exports["default"] = _default;